export const iconFontAwesomeMoneyLiraSign = (
	<i className="fa-solid fa-lira-sign"></i>
);
